import React, { Component } from 'react';
import axios from 'axios';
import { sortBy } from 'lodash';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
// material
import { withStyles, Theme } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
// app
import { updateSession } from '../../store/action-creators';
// containers
import AppContainer from '../../containers/App';
// components
import Loading from '../../components/site/Loading';
import CampaignContactsTable from '../../components/campaign/CampaignContactsTable';
import BackButton from '../../components/buttons/BackButton';
// services
import AuthService from '../../services/auth';
// entities
import { Session } from '../../entities/auth';
import { CampaignContactES, CampaignContact, Campaign } from '../../entities/site';


export interface ClicksTableType {
  name: string,
  phone: string,
  date: string
}
const styles: any = (theme: Theme) => ({
  pageContainer: {
    padding: "0px 20px",
    marginBottom: "100px",
    [theme.breakpoints.down('sm')]: {
      padding: "0px !important",
    }
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 10
  },
  headerTitle: {
    fontSize: "22px",
    letterSpacing: "1px",
    fontWeight: "bold"

  },
  formControl: {
    minWidth: "200px",
    [theme.breakpoints.down('xs')]: {
      minWidth: "150px"
    }
  },
})

interface RepliesPageProps {
  history: any;
  session: Session;
  updateSession(session: Session): void;
}

interface RepliesPageState {
  loading: boolean,
  campaignContactsES: CampaignContactES[],
  campaignContacts: CampaignContact[],
  campaignId: string,
  campaigns: Campaign[]
}
class RepliesPage extends Component<RepliesPageProps, RepliesPageState>{
  constructor(props: RepliesPageProps) {
    super(props);
    this.state = {
      loading: false,
      campaignContactsES: [],
      campaignContacts: [],
      campaignId: '',
      campaigns: []
    };

  }


  componentDidMount = async () => {

    this.fetchCampaigns();

  }

  fetchCampaigns = async () => {
    try {

      this.setState({ loading: true });

      let totalReplies = 0;
      const campaignsRes = await axios.get(`${AuthService.getApiUrls().site}/campaigns?status=active`);
      const filtered = sortBy(campaignsRes.data.results, 'createdDate').reverse();

      campaignsRes.data.results.map((campaign: Campaign) => {
        totalReplies = totalReplies + campaign.totalActive;
      });

      if (filtered.length) {
        this.setState({ campaigns: filtered, campaignId: filtered[0].id});
        this.fetchReplies(totalReplies, filtered, filtered[0].id);
      }

    } catch (error) {
      console.log('error', error);
    } finally {
      this.setState({ loading: false });
    }

  }

  fetchReplies = async (total: number, campaigns: Campaign[], campaignId: string,) => {
    try {

      this.setState({loading: true});

      const url = `${AuthService.getApiUrls().site}/campaign/${campaignId}/contacts?limit=500&status=active`;
      const campaignContactsRes = await axios.get(url);

      this.setState({
        loading: false,
        campaignContacts: campaignContactsRes.data.results
      })

    }   catch (error) {
      this.setState({loading: false});
      console.log('error', error);
    }
  }

  fetchRepliesOld = async (total: number, campaigns: Campaign[], campaignId?: string,) => {

    try {

      this.setState({ loading: true });

      const campaignIds: string[] = [];

      // build match
      const mustArray: any = [
        {
          match: {
            status: {
              query: "active",
              operator: 'and'
            }
          }
        }
      ];
      if (campaignId) {
        mustArray.push({
          match: {
            campaignId: {
              query: campaignId,
              operator: "and"
            }
          }
        });
        campaignIds.push(campaignId);
      }
      else {
        campaigns.forEach((campaign: Campaign) => {
          mustArray.push({
            match: {
              campaignId: {
                query: campaign.id,
                operator: 'or'
              }
            }
          });
          campaignIds.push(campaign.id);
        });
      }

      const search: any = {
        query: {
          bool: {
            must: mustArray
          }
        },
        size: total
      };

      const campaignContactsRes = await axios.post(`${AuthService.getApiUrls().site}/campaign/contacts/_search`, search);
      const campaignContactsES: CampaignContactES[] = campaignContactsRes.data.hits.hits;
      let contacts: CampaignContact[] = [];
      campaignContactsES.forEach((campaignContactES: CampaignContactES) => {
        contacts.push(campaignContactES._source);
      });
      contacts = sortBy(contacts, 'firstName');

      const newSession = this.props.session;
      newSession.campaignContacts = contacts;
      this.props.updateSession(newSession);

      this.setState({
        loading: false,
        campaignContactsES,
        campaignContacts: contacts
      })

    } catch (error) {
      console.log('error', error);
    }

  }

  handleClick = (contact: CampaignContact) => {
    this.props.history.push(`/campaign/${contact.campaignId}/contact/${contact.id}/type/replies`);
  }

  handleChange = async (event: React.ChangeEvent<{ value: string }>) => {

    try {

      const campaignId = event.target.value;
      this.setState({
        campaignId
      });

      const campaignRes = await axios.get(`${AuthService.getApiUrls().site}/campaign/${campaignId}`);

      this.fetchReplies(campaignRes.data.totalClicks, [], event.target.value);

    } catch (error) {
      console.log('error', error);
    }

  };

  render() {
    const { classes }: any = this.props;
    const today = new Date().toLocaleDateString();

    return (
      <AppContainer maxWidth="lg">
        <Loading open={this.state.loading} />
        <div className={classes.pageContainer}>
          <BackButton text="Back to campaigns" onClick={() => this.props.history.push(`/campaigns`)} />
          <div className={classes.headerContainer}>
            <div className={classes.headerTitle}>Replies</div>
            <div >
              <CSVLink
                data={this.state.campaignContacts}
                filename={`campaign-replies-${today}.csv`}
                className="csv-link"
              >Export to cvs</CSVLink>
              <FormControl variant="outlined" className={classes.formControl} size="small">
                <InputLabel style={{ color: "#5A72A2" }} id="campaign-label">Campaigns</InputLabel>
                <Select
                  labelId="campaign"
                  id="campaign"
                  value={this.state.campaignId}
                  onChange={this.handleChange}
                  label="All Campaigns"
                >
                  <MenuItem value={""}>All</MenuItem>
                  {this.state.campaigns.map((campaign: Campaign, index) => (
                    <MenuItem value={campaign.id} key={`campaign-${index}`}>{`${campaign.name} - ${campaign.totalActive} replies`}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
          <div>
            <CampaignContactsTable contacts={this.state.campaignContacts} onClick={this.handleClick} />
          </div>
        </div>
      </AppContainer>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    session: state.session.session
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ updateSession }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(withStyles(styles)(RepliesPage)));


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignReplies.tsx